
import { useState } from 'react';

export const usePagination = ({ contentPerPage, count }) => {
  const [page, setPageState] = useState(1);
  const pageCount = Math.ceil(count / contentPerPage);
  const lastContentIndex = page * contentPerPage;
  const firstContentIndex = lastContentIndex - contentPerPage;

  const changePage = (direction) => {
    setPageState((state) => {
      if (direction) {
        if (state === pageCount) {
          return state;
        }
        return state + 1;
      } else {
        if (state === 1) {
          return state;
        }
        return state - 1;
      }
    });
  };

  const setPage = (num) => {
    if (num > pageCount) {
      setPageState(pageCount);
    } else if (num < 1) {
      setPageState(1);
    } else {
      setPageState(num);
    }
  };

  return {
    totalPages: pageCount,
    nextPage: () => changePage(true),
    prevPage: () => changePage(false),
    setPage: setPage,
    firstContentIndex,
    lastContentIndex,
    page,
  };
};

